import { Redirect, Route } from "react-router-dom";

const PrivateRoute = ({ isToken, component: Component, ...rest }) => {
  localStorage.setItem("lastPath", rest.location.pathname);

  return (
    <Route
      {...rest}
      render={(props) =>
        isToken ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
};

export default PrivateRoute;
